module.exports = __webpack_public_path__ + "img/delete.053f3458.svg";